import React from 'react';
import { useTranslation } from 'react-i18next';
import { Nav, Navbar, Button } from 'reactstrap'
const Header = ({ handleClose, referenceId }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-light font-weight-bold d-flex px-3 py-2">
      <div className="align-self-center">
        {t(`${referenceId ? 'contracts.options.referenced_document' : 'contracts.tooltip.new_contract'}`)}
      </div>
      <div className="ml-auto">
        <Button onClick={handleClose} color="default">
          <i className="fas fa-times"></i>
        </Button>
      </div>
    </div>
  );
};
export default Header;
